import './index.styl';
import template from './index.jst';
import FieldCoreView from '../Field/Core';

import _ from 'lodash';

const silent = { silent: true };

export class Bench extends FieldCoreView {
	get template() {
		return template;
	}

	get className() {
		return 'player-bench-container';
	}

	initialize(args) {
		super.initialize(args);

		this.model.set({
			is_opened: true
		});

		this.listenTo(this.model, 'change:team', this.onChangeLineup);
	}

	onChangeLineup() {
		const
			convertToId = player => _.isNumber(player) ? player : player.id,
			is_opened = this.model.get('is_opened'),
			prevBench = this.model.previousAttributes()
				.lineup.bench.map(convertToId)
				.filter(_.identity)
				.length,
			bench = this.model.get('lineup')
				.bench.map(convertToId)
				.filter(_.identity)
				.length,
			is_different = bench && prevBench !== bench;

		if (!is_opened && is_different) {
			this.toggleBench();
		}
	}

	ui() {
		return {
			...super.ui(),
			toggle: '.js-player-bench-toggle-btn',
			close: '.js-player-bench-close',
			bench: '.js-team-filed-bench'
		}
	}

	events() {
		return {
			...super.events(),
			'click @ui.toggle': 'toggleBench',
			'click @ui.close': 'toggleBench',
		}
	}

	toggleBench() {
		let { bench, toggle } = this.ui,
			is_opened = !bench.hasClass('hidden');

		this.model.set({ is_opened: !is_opened }, silent);

		$([bench, toggle]).toggleClass('hidden');
	}

	onDomRefresh() {
		this.applyStyleWithCoachBanner();
	}

	applyStyleWithCoachBanner() {
		this.$el.toggleClass('with-coach-banner', this.model.get('is_show_banner'));
	}

	setStyleWithCoachBanner(is_show_banner) {
		this.model.set({ is_show_banner }, silent);
		this.applyStyleWithCoachBanner();
	}
}

export default Bench;